<template>
  <div class="w-full pt-5 pb-5">
    <div class="flex">
      <back-button label="Back" @onClick="
        $router.push({
          name: 'EssMSSPerformance',
          query: { activeTab: 'Direct Report Agreements' },
        })
        " variant="secondary" class="mr-4" />
      <div class="mt-4" style="border-left: 1px solid #878e99; height: 1.5rem" />

      <div style="width: 220px">
        <h1 class="text-xl text-left font-extrabold ml-4 mt-3">
          Draft Agreement
        </h1>
      </div>

      <div class="w-7/12 mt-4">
        <Breadcrumb :items="breadcrumbs" />
      </div>
    </div>

    <div style="height: 100%" class="mt-20" v-if="loading">
      <loader size="xxs" :loader-image="false" />
    </div>

    <div v-else>
      <ValidationObserver rules="required" v-slot="{ handleSubmit }">
        <div class="px-3">
          <card class="p-5 mt-3">
            <p class="text-lg font-bold">Agreement Details</p>
            <div class="grid grid-cols-12 gap-7" style="margin-top: 1.125rem">
              <div class="col-span-4 mt-2">
                <div class="text-sm text-jet -mb-1">Financial Year</div>
                <div class="date-flex mt-2" :style="periodError ? 'border : 1px solid red' : ''">
                  <datepicker placeholder="--Select Day & Month & Year--" style="width: 100%; outline: none"
                    input-class="date-input" format="yyyy" minimum-view="year" @selected="periodSelect"
                    v-model="payload.year" />
                </div>
                <small data-v-d5a084b0="" class="mt-1 text-red-700 text-xs font-semibold" v-if="periodError">Financial
                  year is not valid.</small>
              </div>

              <div class="col-span-4">
                <c-text placeholder="--Enter--" variant="w-full" class="mt-2" v-model="payload.title"
                  label="Description" :disabled="true" />
              </div>

              <div class="col-span-4">
                <c-text label="Template" placeholder="--Template--" variant="w-full" class="mt-2"
                  v-model="selectedTemplate" :disabled="disabledTemplate" />
              </div>
            </div>

            <div class="w-full p-2 h-auto flex flex-col mt-5 cycle" v-if="selectedTemplate !== ''">
              <div class="w-11/12 flex cycle__text">CYCLE DETAILS</div>

              <div class="w-full h-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4">
                <card class="fcard">
                  <div class="w-full flex h-auto">
                    <div class="fcard__icon">
                      <icon :icon-name="doccycle" size="csm" />
                    </div>
                    <div class="w-full flex flex-col h-auto">
                      <div class="fcard__header" style="color: #490166">
                        {{ cycleTitle }}
                      </div>
                      <div class="w-full fcard__text">
                        {{ cycleDescription }}
                      </div>
                    </div>
                  </div>
                </card>

                <card class="fcard">
                  <div class="w-full flex h-auto">
                    <div class="fcard__icon">
                      <icon :icon-name="calendarIcon" size="csm" />
                    </div>
                    <div class="w-full flex flex-col h-auto">
                      <div class="fcard__header" style="color: #e99323">
                        Cycle Period
                      </div>
                      <div class="w-full fcard__text">
                        {{ $DATEFORMAT(new Date(cycleStartPeriod), "MMMM dd") }}
                        -
                        {{ $DATEFORMAT(new Date(cycleEndPeriod), "MMMM dd") }}
                      </div>
                    </div>
                  </div>
                </card>

                <card class="fcard" v-for="(cycles, index) in appraisal_cycles" :key="index">
                  <div class="w-full flex h-auto">
                    <div class="fcard__icon">
                      <icon :icon-name="reviewIcon" size="csm" />
                    </div>
                    <div class="w-full flex flex-col h-auto">
                      <div class="fcard__header" style="color: #2176ff">
                        {{ cycles.name }}
                      </div>
                      <div class="w-full fcard__text">
                        {{
                          $DATEFORMAT(new Date(cycles.appraisal_starts), "MMMM dd")
                        }}
                        -
                        {{
                          $DATEFORMAT(new Date(cycles.appraisal_ends), "MMMM dd")
                        }}
                      </div>
                    </div>
                  </div>
                </card>
              </div>
            </div>

            <div class="w-full p-2 h-auto flex flex-col mt-5" style="border: 1px dashed #878e99; border-radius: 5px"
              v-else>
              <div class="w-11/12 h-6 p-1 flex cyc-text">PERFORMANCE DETAILS</div>
              <div class="w-11/12 h-6 p-1 mt-4 mb-3 inner-text">
                --Select a Performance Template to view Appraisal Performance
                Details here---
              </div>
            </div>

            <div class="w-full p-2 h-auto flex flex-col mt-5" style="border: 1px dashed #878e99; border-radius: 5px">
              <div class="w-full flex">
                <div class="w-auto h-6 p-1 flex flex-grow cyc-text uppercase">
                  Create For
                </div>
                <div class="text-flame font-semibold flex mb-1 p-2 text-base cursor-pointer" @click="addEmployees()">
                  <icon icon-name="icon-plus" class="mr-2" size="xs" />
                  Employees
                </div>
              </div>
              <div class="w-full p-1 mb-3 inner-text">
                <div class="w-full flex flex-wrap">
                  <div class="mb-3 w-1/3 flex border p-3 mr-2"
                    style="border-radius: 5px; width: 32.6%; background-color: rgba(247, 247, 255, 1);"
                    v-for="(item, index) in selectedEmployees" :key="index">
                    <div class="w-full flex">
                      <div class="flex flex-grow">
                        <div class="flex">
                          <img class="mr-3" :src="item.photo" v-if="item.photo" alt="user photo" style="
                              height: 30px;
                              width: 30px;
                              border-radius: 5px;
                            " />
                          <div style="
                              height: 30px;
                              width: 30px;
                              border-radius: 5px;
                            " class="text-blueCrayola mr-3 flex justify-center border text-center font-semibold"
                            v-else>
                            {{ $getInitials(`${item.fname} ${item.lname}`) }}
                          </div>
                        </div>
                        <div class="flex flex-col flex-grow">
                          <p class="flex -mt-1">
                            {{ `${item.fname} ${item.lname}` }}
                          </p>
                          <div class="text-xs flex -mt-1 font-semibold w- text-romanSilver uppercase">
                            <p class="opacity-50 mr-2" style="font-size: 10px">
                              {{
                                `${item.userDesignation
                                  ? item.userDesignation
                                  : "---"
                                }`
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="flex">
                        <span class="flex cursor-pointer" @click="viewEmployeeDetails(item.id)">
                          <Badge label="View" variant="primary" background-color="rgba(33, 118, 255, 0.08)"
                            color="#2176FF" class="capitalize" style="
                              margin-right: 12px;
                              font-size: 14px;
                              padding: 5px;
                              height: 25px;
                              margin-top: 0.5rem;
                              border-radius: 5px;
                            " />
                        </span>
                        <span class="flex cursor-pointer" @click="removeEmployee(index, item)">
                          <icon icon-name="close" class-name="text-darkPurple cursor-pointer" size="xs" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>

        <div class="px-3">

          <div style="height: 100%" class="mt-20" v-if="loadingKPAs">
            <loader size="xxs" :loader-image="false" />
          </div>

          <card class="p-5" style="margin-top: 4px" v-else>
            <div class="w-full flex flex-row" style="margin-top: 20px; height: 44px; flex-grow: 1">
              <div class="w-full h-auto mt-2">
                <h1 class="text-base font-bold">KPAs</h1>
              </div>

              <div class="w-full flex justify-end items-center">
                <div class="p-2 mx-3 bg-ghostWhite h-full flex items-center" style="border-radius: 5px">
                  <span class="text-sm font-black flex flex-row items-center flex-grow mt-2">
                    Total Allocated Weight:
                  </span>
                  <span class="text-sm ml-3 mt-2" :class="allocatedWeight === 100 ? 'text-darkPurple' : 'text-desire'">
                    {{ allocatedWeight }}%
                  </span>
                  <icon :icon-name="iconInfo" size="ksm" />
                </div>
              </div>
            </div>

            <div style="border-bottom: 1px solid #878e99; height: 1rem" />

            <div class="w-full h-auto my-6 flex flex-col" style="align-items: center"
              v-if="templateKPATypes.length === 0">
              <div class="w-5/12 h-auto mb-4 mt-4 flex" style="justify-content: center">
                <icon :icon-name="illustration" size="auto" class-name="icon-Size mb-2" />
              </div>
              <div class="w-6/12 h-auto illu-text">
                You set organizational goals and objectives here. KPAs appear
                here when you select a template. You can edit selected template
                based on permissions assigned. Select a template to get started.
              </div>
            </div>

            <div class="flex flex-col w-full my-4" v-else>

              <div class="w-full">
                <accordion v-for="(kpaTypes, index) in templateKPATypes" :key="`kpa-${index}`" class="mt-4" show-divider
                  :is-open="true" @open="handleOpen">
                  <template v-slot:title>
                    <ValidationObserver :ref="`kpa-observer-${kpaTypes.id}`">
                      <div class="flex items-center gap-2">
                        <span class="font-bold">{{ kpaTypes.name }}</span>
                        <button @click="createNewKPA(kpaTypes)">
                          <icon icon-name="icon-plus" size="xs" class="text-flame" />
                        </button>
                        <span class="flex cursor-pointer text-blueCrayola" @click="toggleEditMode(kpaTypes)">
                          <icon :icon-name="isKpaEditable(kpaTypes) ? 'icon-save' : 'icon-edit'" size="xs" />
                        </span>
                      </div>
                    </ValidationObserver>
                  </template>

                  <template v-slot:block>
                    <div class="flex items-center bg-gray-100 rounded px-2 py-1 gap-1 mr-3">
                      <span class="font-black text-xs">
                        {{ getKPAWeight(kpaTypes, kpaTypes.id) }} %
                      </span>
                    </div>
                  </template>

                  <div class="flex flex-col w-full -mt-2">
                    <!-- Strategic Goal Section -->
                    <div class="w-full mb-6 p-4 bg-alertRed rounded-lg shadow-sm">
                      <h2 class="text-base font-bold text-gray-800 mb-2">STRATEGIC GOAL</h2>
                      <p class="text-gray-600">{{ kpaTypes.description }}</p>
                    </div>

                    <!-- KPA Items -->
                    <div class="w-full flex flex-col gap-6">
                      <accordion class="px-5 py-3 mb-0 bg-gray-50 shadow-sm rounded-lg" :iconClass="'mt-4'"
                        v-for="(item, index) in kpaTypes.kpas" :key="'kpi-' + index" :is-open="true">
                        <template v-slot:block>
                          <div class="w-full flex flex-col lg:flex-row items-start justify-between gap-4">
                            <div class="flex items-start w-full lg:w-auto flex-1 gap-2">
                              <div class="flex items-center" :class="!item.isEdit ? 'h-7 mt-1' : 'h-8 mt-2'">
                                <button @click="deleteKPA(index, kpaTypes)"
                                  class="text-gray-500 hover:text-red-500 transition-colors">
                                  <icon icon-name="icon-trash" size="xs" />
                                </button>
                              </div>

                              <div :class="!item.isEdit ? 'h-6 mt-1' : 'h-8 mt-2'"
                                class="w-auto mx-2 flex items-center">
                                <span class="w-px bg-gray-300" :class="!item.isEdit ? 'h-6' : 'h-8'"></span>
                              </div>

                              <div v-if="!item.isEdit" class="flex gap-2 whitespace-nowrap mt-2">
                                <span class="font-bold text-flame text-sm">KPI:</span>
                                <span class="font-semibold text-sm" v-tooltip.bottom-middle="item.name
                                  ">{{ item.name }}</span>
                              </div>

                              <div v-else class="min-w-[200px] lg:min-w-[250px]">
                                <div class="flex items-center gap-2 w-full">
                                  <span class="font-bold mt-1 text-flame text-sm whitespace-nowrap">KPI :</span>
                                  <c-text placeholder="--Enter--" variant="w-full" :style="'width: 20rem'"
                                    v-model="item.name" />
                                </div>
                              </div>

                              <div :class="!item.isEdit ? 'h-6 mt-1' : 'h-8 mt-2'"
                                class="w-auto mx-2 flex items-center">
                                <span class="w-px bg-gray-300" :class="!item.isEdit ? 'h-6' : 'h-8'"></span>
                              </div>

                              <!-- Objective Field -->
                              <div v-if="!item.isEdit" class="flex gap-2 whitespace-nowrap mt-2">
                                <span class="font-bold text-flame text-sm">Objective:</span>
                                <span class="font-semibold text-sm" v-tooltip.bottom-middle="item.objective">{{
                                  item.objective }}</span>
                              </div>

                              <div v-else class="flex-1 min-w-[200px] lg:min-w-[250px]">
                                <div class="flex items-center gap-2 w-full">
                                  <span class="font-bold mt-1 text-flame uppercase text-sm whitespace-nowrap">Objective
                                    :</span>
                                  <c-text placeholder="--Enter--" variant="w-full" class="w-[300px]"
                                    :style="'width: 20rem'" v-model="item.objective" />
                                </div>
                              </div>
                            </div>

                            <div class="w-full lg:w-auto lg:ml-8 mt-2 mr-3 lg:mt-0">
                              <div v-if="!item.isEdit" class="p-2 w-auto flex gap-2 items-center rounded-sm mr-2 mt-1">
                                <span class="font-black text-xs">{{ item.weight }}%</span>
                              </div>

                              <div v-else class="flex items-center gap-2">
                                <span class="font-bold mt-1 text-flame uppercase text-sm whitespace-nowrap">Weight
                                  :</span>
                                <c-text placeholder="--Enter--" variant="w-full" class="w-14" type="number" min="0"
                                  max="100" v-model="item.weight" @input="validateWeight(item.weight)" />
                              </div>
                            </div>
                          </div>
                        </template>
                        <div class="w-full h-[1px] mb-6 -mt-2 border border-2" />

                        <div class="w-full flex flex-col gap-1">
                          <span class="text-sm uppercase font-bold">Criteria</span>
                        </div>
                        <div class="w-full grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3">
                          <div v-for="(n, rating) in (item.kpis)" :key="rating">
                            <c-text variant="w-full" :placeholder="`Criteria`"
                              v-tooltip.bottom-middle="item.kpis[rating].criteria" :disabled="!item.isEdit"
                              v-model="item.kpis[rating].criteria" />
                          </div>
                        </div>
                      </accordion>
                    </div>
                  </div>
                </accordion>
              </div>
            </div>
          </card>
        </div>

        <div class="w-full px-4 flex mt-5">
          <div class="w-full flex gap-3 bg-alertRed rounded-lg shadow-sm p-3">
            <icon :icon-name="'bulb-alert'" size="xsm" />
            <span class="text-sm">
              Employees can edit the shared agreement and resubmit it for your review and/or approval.
              Once approved, the agreement is locked and can no longer be edited.
            </span>
          </div>
        </div>

        <div class="pl-3 flex mt-5">
          <div class="flex flex-grow">
            <Button :disabled="disableBtn || selectedEmployees.length === 0 || !isFormValid"
              :class="disableBtn ? 'btn-disabled' : 'bg-dynamicBackBtn text-white'" width="auto" @click="
                () => {
                  payload.isDraft = false;
                  handleSubmit(submit)
                }">
              <span class="mr-6 ml-6">Share with employee(s)</span>
            </Button>

            <Button background-color="none" class="ml-4" style="color: #321c3b" @click="$router.back()">
              Cancel
            </Button>
          </div>
          <div class="flex justify-end mr-5">
            <Button class="text-dynamicBackBtn border border-solid border-dynamicBackBtn text-center" width="8rem"
              @click="
                () => {
                  payload.isDraft = false;
                  submit('draft')
                }
              " v-if="payload.status === 'draft' && payload.title !== ''">
              Save as Draft
            </Button>
          </div>
        </div>
      </ValidationObserver>

      <RightSideBar v-if="addEmployeesModal" @close="addEmployeesModal = false" submit="Proceed"
        @submit="employeeSubmit()" :button-class="`bg-dynamicBackBtn text-white`">
        <template v-slot:title>
          <div class="w-full flex">
            <p class="text-darkPurple mt-3">Add Employees</p>
          </div>
        </template>
        <template v-slot:subtitle>
          <div class="flex flex-col w-full mb-3">
            <p class="my-2 text-base">
              Add employees for whom you are creating a performance agreement
              for.
            </p>
            <p>
              Please note that by sharing, this agreement will override all
              previously shared agreements.
            </p>
          </div>
        </template>

        <search-input class="my-4" v-model="startSearch" placeholder="Search" />

        <div class="border border-dashed my-4 w-full" />

        <div style="height: 100%" v-if="loadingBar">
          <loader size="xxs" :loader-image="false" />
        </div>
        <div v-else>
          <div v-for="(item, index) in employees" :key="index"
            class="flex flex-col py-4 userContainer border-b border-dashed">
            <div class="flex items-center">
              <div>
                <img class="mr-3" :src="item.photo" v-if="item.photo" alt="user photo"
                  style="height: 35px; width: 35px; border-radius: 5px" />
                <div style="height: 35px; width: 35px; border-radius: 5px"
                  class="text-blueCrayola mr-3 flex justify-center border text-center font-semibold pt-1" v-else>
                  {{ $getInitials(`${item.fname} ${item.lname}`) }}
                </div>
              </div>
              <div class="flex flex-col gap-2 -mb-2 flex-grow">
                <p>
                  {{ `${item.fname} ${item.lname}` }}
                </p>
                <div class="text-xs flex font-semibold -mt-1 w- text-romanSilver uppercase">
                  <p class="opacity-50 mr-2" style="font-size: 10px">
                    {{
                      `${item.userDesignation ? item.userDesignation : "---"}`
                    }}
                  </p>
                  <p class="opacity-50 ml-1 mr-2" style="font-size: 10px">
                    <span class="dot dot-circle secondary" style="width: 6px; height: 6px" />
                  </p>
                  <p class="opacity-50 mr-2" style="font-size: 10px">
                    {{ `${item.function ? item.function : "---"}` }}
                    {{ item.sharedAgreement }}
                  </p>
                  <p class="ml-2 opacity-50 text-romanSilver" v-if="item.sharedAgreement === ''"
                    style="font-size: 10px">
                    Not shared yet
                  </p>
                  <p class="ml-2 opacity-50 text-carrotOrange" v-if="
                    item.sharedAgreement === 'submitted' && !item.approved
                  " style="font-size: 10px">
                    Submitted and Pending
                  </p>
                  <p class="ml-2 opacity-50 text-mediumSeaGreen"
                    v-if="item.sharedAgreement === 'submitted' && item.approved" style="font-size: 10px">
                    Submitted and Approved
                  </p>
                  <p class="ml-2 opacity-50 text-carrotOrange cursor-pointer underline" v-if="
                    item.sharedAgreement === 'shared' ||
                    item.sharedAgreement === 'pending'
                  " style="font-size: 10px" @click="$router.push({
                    name: 'EssPerformanceEmployeeDetails',
                    params: { id: item.id, year: payload.year },
                  })">
                    Shared with you
                  </p>
                </div>
                <div class="text-xs flex font-semibold w- text-romanSilver uppercase">
                  {{ item.template }}
                </div>
                <p class="opacity-50 uppercase text-carrotOrange" v-if="item.text !== ''" style="font-size: 10px">
                  {{ item.text }}
                </p>
              </div>
              <checkbox v-if="!item.disabled" checkbox-size="height:16px; width:16px; margin:4px 7px 8px 8px;"
                label-style="color:#333333; " :class="item.approved ||
                  item.text === 'Selected Template not applicable to employee'
                  ? `opacity-30 mr-6`
                  : 'mr-6'
                  " :value="item.selected" v-model="item.selected" />
            </div>
          </div>
        </div>
      </RightSideBar>

      <RightSideBar v-if="viewEmployeesModal" close-button @close="viewEmployeesModal = false"
        :button-class="`bg-dynamicBackBtn text-white`">
        <template v-slot:title>
          <div class="w-full flex">
            <p class="text-darkPurple mt-3">Employee Details</p>
          </div>
        </template>

        <div style="height: 100%" class="mb-4 mt-10" v-if="loadingEmp">
          <loader size="xxs" :loader-image="false" />
        </div>

        <div class="flex items-center mb-3" v-else>
          <div>
            <img class="mr-3" :src="viewEmployee.photo" v-if="viewEmployee.photo" alt="user photo"
              style="height: 80px; width: 80px; border-radius: 5px" />
            <div style="height: 80px; width: 80px; border-radius: 5px"
              class="text-blueCrayola mr-3 flex justify-center border text-center font-semibold pt-7" v-else>
              {{ $getInitials(`${viewEmployee.fname} ${viewEmployee.lname}`) }}
            </div>
          </div>
          <div class="flex flex-col">
            <span class="text-lg font-bold">
              {{ `${viewEmployee.fname} ${viewEmployee.lname}` }}
            </span>
            <span class="font-semibold text-sm">
              {{
                viewEmployee.employeeId === null
                  ? `---- `
                  : viewEmployee.employeeId
              }}
            </span>
            <span class="text-romanSilver uppercase" style="font-size: 10px">
              Since {{ formatEmployeeDate(viewEmployee.employmentDate) }}
            </span>
          </div>
        </div>

        <div v-if="!loadingEmp">
          <div class="border border-dashed mb-4" />

          <div class="w-full my-4">
            <span class="text-base font-semibold"> Work Details </span>
          </div>
          <div class="flex flex-col w-full">
            <div class="w-full flex">
              <card class="flex p-3 mb-4 w-1/2 mr-3 flex-grow">
                <div class="flex flex-col">
                  <div class="flex">
                    <icon icon-name="icon-suitcase" size="xs" />
                    <span class="ml-1 text-chartPurple text-xs">
                      Designation
                    </span>
                  </div>
                  <div class="text-xs ml-5 mt-1 font-semibold uppercase">
                    {{ viewEmployee.userDesignation }}
                  </div>
                </div>
              </card>
              <card class="flex p-3 mb-4 w-1/2 flex-grow">
                <div class="flex flex-col">
                  <div class="flex">
                    <icon icon-name="icon-department" size="xs" />
                    <span class="ml-1 text-carrotOrange text-xs">
                      Function
                    </span>
                  </div>
                  <div class="text-xs ml-5 mt-1 font-semibold uppercase">
                    {{ viewEmployee.employeeFunction }}
                  </div>
                </div>
              </card>
            </div>
            <div class="w-full flex">
              <card class="flex p-3 mb-4 w-1/2 mr-3 flex-grow">
                <div class="flex flex-col">
                  <div class="flex">
                    <icon icon-name="levels" color="#FFFFFF" size="xs" />
                    <span class="ml-1 text-desire text-xs"> Level </span>
                  </div>
                  <div class="text-xs ml-5 mt-1 font-semibold uppercase">
                    {{ viewEmployee.level }}
                  </div>
                </div>
              </card>
              <card class="flex p-3 w-1/2 mb-4 flex-grow">
                <div class="flex flex-col">
                  <div class="flex">
                    <icon icon-name="line-manager" color="#FFFFFF" size="xs" />
                    <span class="ml-1 text-blueCrayola text-xs">
                      Line Manager
                    </span>
                  </div>
                  <div class="text-xs ml-5 mt-1 font-semibold uppercase">
                    {{ viewEmployee.reportingTo }}
                  </div>
                </div>
              </card>
            </div>
          </div>

          <div class="w-full flex">
            <card class="flex p-3 mb-4 w-1/2 mr-3 flex-grow">
              <div class="flex flex-col">
                <div class="flex">
                  <icon icon-name="icon-manager" color="#878E99" size="xs" />
                  <span class="ml-1 text-mediumSeaGreen text-xs">
                    Supervisory Function
                  </span>
                </div>
                <div class="text-xs ml-5 mt-1 font-semibold uppercase sd" v-if="viewEmployee.supervisory">
                  {{ viewEmployee.userDesignation }}
                </div>
                <div class="text-xs ml-5 mt-1 font-semibold uppercase" v-else>
                  ----
                </div>
              </div>
            </card>
            <card class="flex p-3 w-1/2 mb-4 flex-grow">
              <div class="flex flex-col">
                <div class="flex">
                  <icon icon-name="icon-display-grid" color="#878E99" size="xs" />
                  <span class="ml-1 text-blueCrayola text-xs">
                    Employment Type
                  </span>
                </div>
                <div class="text-xs ml-5 mt-1 font-semibold uppercase">
                  {{ viewEmployee.employmentType }}
                </div>
              </div>
            </card>
          </div>

          <div class="border border-dashed w-full" />

          <div class="w-full my-4">
            <span class="text-base font-semibold"> Others </span>
          </div>
          <div class="flex flex-col w-full">
            <div class="w-full flex">
              <card class="flex p-3 mb-4 mr-3 flex-grow">
                <div class="flex flex-col">
                  <div class="flex">
                    <icon icon-name="message" size="xms" />
                    <span class="ml-2 text-blueCrayola text-xs"> Email </span>
                  </div>
                  <div class="text-xs ml-5 mt-1 font-semibold">
                    {{ viewEmployee.email }}
                  </div>
                </div>
              </card>
              <card class="flex p-3 mb-4">
                <div class="flex flex-col">
                  <div class="flex">
                    <icon icon-name="icon-phone" size="xs" />
                    <span class="ml-1 text-carrotOrange text-xs"> Phone </span>
                  </div>
                  <div class="text-xs ml-5 mt-1 font-semibold uppercase">
                    {{ viewEmployee.phoneNo }}
                  </div>
                </div>
              </card>
            </div>

            <div class="w-full flex">
              <card class="flex p-3 mb-4 mr-3 flex-grow">
                <div class="flex flex-col">
                  <div class="flex">
                    <icon icon-name="map-pin" size="xms" />
                    <span class="ml-2 text-dome text-xs">
                      Office Location
                    </span>
                  </div>
                  <div class="text-xs ml-5 mt-1 font-semibold uppercase">
                    {{ viewEmployee.office }}
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </RightSideBar>
    </div>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import Datepicker from "vuejs-datepicker";
import BackButton from "@scelloo/cloudenly-ui/src/components/back-button";
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import CText from "@scelloo/cloudenly-ui/src/components/text";
import CTextarea from "@scelloo/cloudenly-ui/src/components/text-area";
import Badge from "@scelloo/cloudenly-ui/src/components/badge";
import SearchInput from "@scelloo/cloudenly-ui/src/components/search-input";
import Card from "@/components/Card";
import Icon from "@/components/Icon";
import Button from "@/components/Button";
import Checkbox from "@/components/Checkbox";
import RightSideBar from "@/components/RightSideBar";
import Accordion from "@/components/Accordion";
import paramsMixin from "@/utilities/paramsMixin";
import timeFormatMixin from "@/utilities/timeFormatMixin";

export default {
  mixins: [paramsMixin, timeFormatMixin],
  components: {
    ValidationObserver,
    BackButton,
    Breadcrumb,
    Icon,
    CText,
    CTextarea,
    Card,
    Button,
    RightSideBar,
    SearchInput,
    Checkbox,
    Badge,
    Accordion,
    Datepicker,
  },
  data() {
    return {
      loading: true,
      breadcrumbs: [
        { text: "Performance", href: "performance" },
        { text: "Performance Agreement", href: "Performance Agreement" },
        { text: "Shared With Me", href: "Shared With Me" },
        { text: "Draft Agreement" }
      ],
      illustration: "illustration",
      inputRules: [
        "required",
        { name: "data", rule: (w) => this.validateEntries(w) }
      ],
      allocatedWeight: 0,
      templateKPATypes: [],
      agreementKPATypes: [],
      weightRules: [
        "required",
        { name: "weight", rule: (w) => this.validateWeight(w) }
      ],
      loadingBar: true,
      loadingEmp: true,
      loadingKPAs: false,
      doccycle: "doc-cycle",
      calendarIcon: "calendar",
      reviewIcon: "reviewicon",
      iconInfo: "icon-info",
      disableBtn: false,
      addEmployeesModal: false,
      periodError: false,
      employees: [],
      selectedEmployees: [],
      viewEmployee: {},
      viewEmployeesModal: false,
      Ratings: [],
      disabledTemplate: true,
      selectedTemplate: "",
      cycleStartPeriod: "",
      cycleEndPeriod: "",
      cycleDescription: "",
      cycleTitle: "",
      appraisal_cycles: [],
      functions: [],
      kpaData: [],
      managerLock: false,
      allEmployees: [],
      startSearch: "",
      payload: {
        orgId: "",
        goalId: "",
        templateId: "",
        isDraft: false,
        title: "",
        year: "",
        status: "draft",
        share_for_review: false,
        created_for: [],
        created_by: "",
        kpa_types: [],
        agreement_status: "pending"
      }
    };
  },

  computed: {
    isFormValid() {

      const allValid = this.templateKPATypes.every(kpaType => {
        return (
          Array.isArray(kpaType.kpas) &&
          kpaType.kpas.length > 0 &&
          kpaType.kpas.every(kpa => {
            const hasName = kpa.name && kpa.name.trim() !== "";
            const hasObjective = kpa.objective && kpa.objective.trim() !== "";
            const hasWeight = kpa.weight !== null && kpa.weight !== "" && !isNaN(kpa.weight);
            const hasCriteria = Array.isArray(kpa.kpis) && kpa.kpis.every(kpi => kpi.criteria && kpi.criteria.trim() !== "");

            return hasName && hasObjective && hasWeight && hasCriteria;
          })
        );
      });

      return allValid && this.allocatedWeight === 100;
    }
  },

  watch: {
    startSearch(query) {
      if (!query) this.employees = this.allEmployees;

      const lowerQuery = query.toLowerCase();

      this.employees = this.allEmployees.filter(emp => {
        return (
          `${emp.fname} ${emp.lname}`.toLowerCase().includes(lowerQuery) ||
          emp.fname.toLowerCase().includes(lowerQuery) ||
          emp.lname.toLowerCase().includes(lowerQuery) ||
          (emp.userDesignation && emp.userDesignation.toLowerCase().includes(lowerQuery)) ||
          (emp.function && emp.function.toLowerCase().includes(lowerQuery))
        );
      });
    }
  },

  methods: {
    resetEmployeeSelections() {
      this.employees.forEach(employee => {
        employee.disabled = false;
        employee.text = "";
        employee.selected = false;
      });
    },

    resetDate(value) {
      return value ? `${value.split("T00:00:00.000Z")[0]}T13:00:00.000Z` : "";
    },

    isKpaEditable(kpaTypes) {
      return kpaTypes.kpas.some(kpa => kpa.isEdit);
    },

    toggleEditMode(kpaTypes) {
      if (!this.isKpaEditable(kpaTypes)) {
        kpaTypes.kpas.forEach(kpa => {
          this.$set(kpa, 'isEdit', true);
        });
      } else {
        const allKPAsValid = kpaTypes.kpas.every(kpa => {
          const hasRequiredFields = kpa.name && kpa.objective && kpa.weight;
          const allKPIsValid = !kpa.kpis || kpa.kpis.every(kpi => kpi.criteria);
          return hasRequiredFields && allKPIsValid;
        });

        if (allKPAsValid) {
          kpaTypes.kpas.forEach(kpa => {
            this.$set(kpa, 'isEdit', false);
          });
          this.payload.isDraft = true;
          this.submit('draft');
        } else {
          this.$toasted.error('Please fill all required fields before saving', {
            duration: 5000
          });
        }
      }
    },

    getCriteriaData(existingKPIs = null) {
      if (existingKPIs) {
        return this.Ratings.map((rating, index) => ({
          id: existingKPIs[index]?.id,
          performanceRatingId: rating.id,
          criteria: existingKPIs[index]?.criteria || ""
        }));
      }

      return this.Ratings.map(rating => ({
        performanceRatingId: rating.id,
        criteria: ""
      }));
    },

    getKPAWeight(kpaType) {
      return kpaType.kpas.reduce((total, kpa) => total + (Number(kpa.weight) || 0), 0);
    },

    validateWeight(weight) {
      if (weight < 0) return "Value must be greater than or equal to 0";

      this.allocatedWeight = this.sumKpaWeights(this.templateKPATypes);
      return true;
    },

    sumKpaWeights(data) {
      return data.reduce((totalWeight, item) => {
        return totalWeight + item.kpas.reduce((sum, kpa) => {
          return sum + (Number(kpa.weight) || 0);
        }, 0);
      }, 0);
    },

    async initializeData() {
      try {

        const [ratingsResponse, settingsResponse, agreementsResponse] = await Promise.all([
          this.$_getPerfomanceRating(),
          this.$_getPerformanceGeneralSetting(),
          this.$_getDirectReportAgreements(this.$AuthUser.id),
          this.getReportingEmployees(),
          this.getAppraisalCycles(),
          this.getFunctions()
        ]);

        this.Ratings = ratingsResponse.data.PerformanceRatings;


        this.processAgreementsData(agreementsResponse.data);
        await this.getGoals(agreementsResponse.data);

      } catch (error) {
        console.error("Initialization error:", error);
        this.$toasted.error("Failed to initialize data", { duration: 5000 });
      } finally {
        this.loading = false;
      }
    },

    processAgreementsData(agreementsData) {

      if (agreementsData.draftAgreement && agreementsData.draftAgreement.length > 0) {
        const draftAgreement = agreementsData.draftAgreement[0].agreement;

        this.payload = {
          ...this.payload,
          orgId: draftAgreement.orgId,
          goalId: draftAgreement.goalId,
          templateId: draftAgreement.templateId,
          title: draftAgreement.description,
          year: draftAgreement.year,
          status: draftAgreement.status,
          created_for: [draftAgreement.created_for],
          created_by: draftAgreement.created_by,
          agreement_status: draftAgreement.agreement_status,
          id: draftAgreement.id
        };

        this.selectedTemplate = agreementsData.draftAgreement[0].templateDetaiils.title;

        const owner = agreementsData.draftAgreement[0].owner;
        this.selectedEmployees = [{
          id: owner.userId,
          fname: owner.fname,
          lname: owner.lname,
          userDesignation: owner.designation,
          function: owner.function,
          photo: owner.photo
        }];

        this.loadKPATypesForAgreement(draftAgreement.id);
      }
    },

    async loadKPATypesForAgreement(agreementId) {
      try {
        const response = await this.$_getOneAgreement(agreementId);
        const kpaTypesData = response.data.agreement.employee_agreement_kpa;

        this.agreementKPATypes = kpaTypesData;

      } catch (error) {
        console.error("Error loading KPA types:", error);
        this.$toasted.error("Failed to load agreement details", { duration: 5000 });
      }
    },

    async getGoals(agreementData) {
      try {

        let goalData = null;
        try {
          const response = await this.$_getOrganizationGoal("");
          goalData = response.data.goals.find(item => item.goal?.year === this.payload.year) || null;
        } catch (error) {
          console.warn("Failed to fetch goal data, falling back to agreement data", error);
        }

        this.setTemplateData(goalData, agreementData);

        this.processEmployees(agreementData);

      } catch (error) {
        console.error("Error loading goals:", error);
        throw error;
      }
    },

    setTemplateData(goalData, agreementData) {
      if (goalData) {
        const { goal } = goalData;
        this.payload = {
          ...this.payload,
          goalId: goal.id,
          templateId: goal.templateId,
          title: goal.goal_performance_templates.agreement_title
        };
        this.selectedTemplate = goal.goal_performance_templates.agreement_title;
        this.cycleDescription = goal.goal_performance_templates.agreement_description;
        this.cycleTitle = this.selectedTemplate;
      } else if (agreementData?.draftAgreement?.length) {
        const draft = agreementData.draftAgreement[0];
        this.payload = {
          ...this.payload,
          goalId: draft.agreement.goalId,
          templateId: draft.agreement.templateId,
          title: draft.agreement.description
        };
        this.selectedTemplate = draft.templateDetaiils.title;
        this.cycleDescription = this.selectedTemplate;
        this.cycleTitle = this.selectedTemplate;
      }
    },

    processEmployees(agreementData) {
      const hasDrafts = agreementData?.draftAgreement?.length > 0;
      const draftOwnerIds = hasDrafts
        ? new Set(agreementData.draftAgreement.map(draft => draft.owner.userId))
        : new Set();


      this.employees = this.employees.map(emp => {
        const isDraftOwner = draftOwnerIds.has(emp.id);
        const disabled = emp.sharedAgreement || !emp.linkNo;

        return {
          ...emp,
          template: emp.linkNo
            ? `${this.selectedTemplate} ${String.fromCharCode(64 + emp.linkNo)}`
            : 'No Linked Template',
          disabled,
          selected: isDraftOwner ? true : (emp.selected ?? false)
        };
      });


      if (hasDrafts) {
        agreementData.draftAgreement.forEach(draft => {
          const owner = draft.owner;
          if (!draftOwnerIds.has(owner.userId)) {
            this.employees.unshift({
              id: owner.userId,
              fname: owner.fname,
              lname: owner.lname,
              userDesignation: owner.designation,
              function: owner.function,
              photo: owner.photo,
              location: owner.location,
              selected: true,
              template: draft.templateDetaiils.title,
              disabled: true,
              approved: draft.agreement.approveAndSubmit,
              agreementId: draft.agreement.id,
              linkNo: 1
            });
          }
        });
      }


      this.allEmployees = [...this.employees];
      this.selectedEmployees = this.employees.filter(emp => emp.selected);

      if (this.selectedEmployees.length > 0) {
        this.employeeSubmit();
      }
    },

    async getReportingEmployees() {
      this.loadingBar = true;
      try {
        const response = await this.$_getManagerDirectReportStatus(
          this.$AuthUser.id,
          new Date().getFullYear()
        );

        this.employees = response.data.sharedAgreements.map(employee => ({
          ...employee.filter,
          id: employee.user.userId,
          fname: employee.user.fname,
          lname: employee.user.lname,
          userDesignation: employee.user.designation,
          function: employee.user.function,
          photo: employee.user.photo,
          selected: false,
          template: null,
          linkNo: employee.templateLinkNo,
          sharedAgreement: employee.agreement?.agreement_status || "",
          approved: employee.agreement?.approveAndSubmit || false,
          disabled: employee.agreement?.agreement_status ? true : false,
          agreementId: employee.agreement?.id || "",
          text: ""
        }));

        this.allEmployees = this.employees;
      } catch (error) {
        console.error("Error loading employees:", error);
        this.$toasted.error("Failed to load employee data", { duration: 5000 });
      } finally {
        this.loadingBar = false;
      }
    },

    async getAppraisalCycles() {
      try {
        const response = await this.$_getAppraisalCycle(this.agreementQuery());
        const appraisal = response.data.AppraisalCycle[0];

        if (appraisal) {
          this.cycleStartPeriod = this.setDates(appraisal.cycle_start_date).toISOString();
          this.cycleEndPeriod = this.setDates(appraisal.cycle_end_date).toISOString();

          this.appraisal_cycles = appraisal.cycles.map(cycle => ({
            name: cycle.name,
            appraisal_starts: this.setDates(cycle.appraisal_starts).toISOString(),
            appraisal_ends: this.setDates(cycle.appraisal_ends).toISOString()
          }));
        }
      } catch (error) {
        console.error("Error loading appraisal cycles:", error);
      }
    },

    async getFunctions() {
      try {
        const response = await this.$_getFunctionKpis("");
        this.functions = response.data.functions.map(f => ({
          id: f.id,
          name: f.name
        }));
      } catch (error) {
        console.error("Error loading functions:", error);
      }
    },

    setEmployeesData(employeesList) {
      this.employees = employeesList.map(employee => ({
        id: employee.id,
        fname: employee.fname,
        lname: employee.lname,
        userDesignation: employee.userDesignation,
        function: employee.function,
        photo: employee.photo,
        selected: employee.selected,
        sharedAgreement: employee.sharedAgreement || "",
        sharedId: employee.sharedId,
        agreementId: employee.agreementId,
        approved: employee.approved || false,
        disabled: false,
        text: ""
      }));
    },

    addEmployees() {
      if (this.payload.year === '') {
        this.$toasted.error("Select a financial year to proceed", { duration: 5000 });
      } else {
        this.addEmployeesModal = true;
      }
    },

    lockKPA(isLocked, data) {
      if (this.managerLock) {
        data.isLocked = !isLocked;
      } else {
        this.$toasted.error(
          "You do not have the privilege to lock or unlock an agreement",
          { duration: 5000 }
        );
      }
    },

    deleteKPA(index, kpaTypes) {
      if (kpaTypes.kpas.length > 1) {
        kpaTypes.kpas.splice(index, 1);
        this.allocatedWeight = this.sumKpaWeights(this.templateKPATypes);
      } else {
        this.$toasted.error(
          "Cannot delete ALL KPIs of a KPA Type, you can edit KPI values instead",
          { duration: 5000 }
        );
      }
    },

    formatEmployeeDate(value) {
      return value ? this.$DATEFORMAT(new Date(value.replace(/.\d+Z$/g, "")), "MMMM dd, yyyy") : "";
    },

    async submit(status) {
      this.kpaData = this.templateKPATypes.map(kpaType => {
        const newKPAs = kpaType.kpas.map(({ state, kpaId, id, target_date, isLocked, isEdit, ...rest }) => ({
          ...rest,
        }));

        return {
          kpa_types_id: kpaType.id,
          description: kpaType.description,
          kpas: newKPAs.every(item => item.name || item.objective || item.weight) ? newKPAs : []
        };
      });

      this.payload = {
        ...this.payload,
        orgId: this.$orgId,
        created_for: this.selectedEmployees.map(s => s.id),
        created_by: this.$AuthUser.id,
        senderId: this.$AuthUser.id,
        kpa_types: this.kpaData,
        year: this.payload.year ? new Date(this.payload.year).getFullYear() : "",
        description: this.payload.title,
        status: status ? "draft" : "active",
        share_for_review: !status,
        agreement_status: !status ? "shared" : this.payload.agreement_status
      };

      if (!this.payload.year) {
        this.periodError = true;
        return;
      }

      this.disableBtn = true;

      try {
        const response = await this.$_createManagerAgreement(this.payload);
        this.$toasted.success(response.data.message, { duration: 5000 });
        window.localStorage.removeItem("createAgreement");
        if (!this.payload.isDraft) {
          this.$router.push({
            name: "EssMSSPerformance",
            query: { activeTab: "Direct Report Agreements" }
          });
        }
        else {
          this.initializeData();
        }
      } catch (error) {
        this.$toasted.error(error.response.data.message, { duration: 5000 });
      }
    },

    async createNewKPA(kpaType) {
      try {

        const isValid = await this.validateKPAType(kpaType);

        if (!isValid) {
          this.$toasted.error("Please fill all required fields before adding a new KPI", { duration: 5000 });
          return;
        }

        if (this.allocatedWeight < 100) {
          kpaType.kpas.push(this.createEmptyKPA());
          this.updateKPAWeights();
        } else {
          this.$toasted.error("Total allocated weight cannot exceed 100%", { duration: 5000 });
        }
      } catch (error) {
        console.error("Error creating new KPA:", error);
      }
    },

    createEmptyKPA() {
      return {
        state: true,
        id: "",
        isLocked: false,
        isEdit: true,
        name: null,
        objective: null,
        kpis: this.getCriteriaData(),
        target_date: null,
        weight: ""
      };
    },

    async validateKPAType(kpaType) {

      for (const kpa of kpaType.kpas) {

        if (!kpa.name?.trim() || !kpa.objective?.trim() || !kpa.weight) {
          return false;
        }


        if (kpa.kpis) {
          for (const criteria of kpa.kpis) {
            if (!criteria.criteria?.trim()) {
              return false;
            }
          }
        }
      }

      if (this.$refs[`kpa-observer-${kpaType.id}`]?.[0]) {
        const isValid = await this.$refs[`kpa-observer-${kpaType.id}`][0].validate();
        if (!isValid) {
          return false;
        }
      }

      return true;
    },

    async periodSelect(data) {
      this.periodError = false;
      this.payload.year = data.getFullYear();

      await this.getGoals();
    },

    handleOpen(state) {
      this.disableBtn = !state;
    },

    async checkValue(value, item) {
      if (value) {
        try {
          const response = await this.$_checkEmployeeSharedAgreement(item.id);
          item.sharedAgreement = response.data.status.submitted;
          if (item.sharedAgreement === "Shared with You") {
            item.sharedId = response.data.sharedAgreement.id;
            item.agreementId = response.data.sharedAgreement.employeePerformanceAgreementId;
          }
        } catch (error) {
          console.error("Error checking shared agreement:", error);
        }
      } else {
        item.sharedAgreement = "";
      }
    },

    async viewEmployeeDetails(employeeId) {
      this.viewEmployeesModal = true;
      this.loadingEmp = true;

      try {
        const response = await this.$_getOneEmployeeAll({ id: employeeId });
        const employee = response.data;
        const functionData = this.functions.find(f => f.id === employee.functionId);

        this.viewEmployee = {
          id: employee.id,
          fname: employee.fname,
          lname: employee.lname,
          photo: employee.photo,
          employeeId: employee.employeeId,
          userDesignation: employee.userDesignation?.name || "",
          employmentDate: employee.employmentDate,
          level: employee.userLevel?.name || "",
          reportingTo: employee.userReportingTo
            ? `${employee.userReportingTo.fname} ${employee.userReportingTo.lname}`
            : "",
          employmentType: employee.employmentType,
          supervisory: employee.userDesignation?.isSupervisory || false,
          email: employee.email,
          phoneNo: employee.phoneNo,
          office: employee.employeeOffice?.name || "",
          employeeFunction: functionData?.name || ""
        };
      } catch (error) {
        console.error("Error loading employee details:", error);
        this.$toasted.error("Failed to load employee details", { duration: 5000 });
      } finally {
        this.loadingEmp = false;
      }
    },

    employeeSubmit() {
      this.selectedEmployees = this.employees.filter(e => e.selected);

      if (this.selectedEmployees.length) {
        const firstLinkNo = this.selectedEmployees[0].linkNo;
        const allSameLinkNo = this.selectedEmployees.every(e => e.linkNo === firstLinkNo);

        if (!allSameLinkNo) {
          this.$toasted.error('Selected employees do not share the same KPA', { duration: 5000 });
          return;
        }
        this.addEmployeesModal = false;
        const params = `?locationId=${this.selectedEmployees[0].locationId}&designationId=${this.selectedEmployees[0].designationId}&functionId=${this.selectedEmployees[0].functionId}&levelId=${this.selectedEmployees[0].levelId}`;
        this.getDesignatedKPAs(params);
      }
    },

    getDesignatedKPAs(params) {
      this.loadingKPAs = true;
      this.$_getDesignatedTemplate(params)
        .then(response => {
          const templateData = response.data.PerformanceTemplate;
          const filteredTemplate = templateData.find(item => item.year === new Date().getFullYear());

          if (!filteredTemplate?.kpa_types) {
            throw new Error("No KPA types found in template data");
          }

          // Create a map of agreement KPAs by type for easy lookup
          const agreementKPAsByTypeMap = this.agreementKPATypes.reduce((acc, agreementKPA) => {
            const typeId = agreementKPA.kpa_type.id;

            if (!acc[typeId]) {
              acc[typeId] = [];
            }

            acc[typeId].push({
              name: agreementKPA.name,
              objective: agreementKPA.objective,
              weight: agreementKPA.weight,
              kpis: agreementKPA.kpis_employee.map(kpi => ({
                criteria: kpi.criteria,
                performanceRatingId: kpi.performanceRatingId
              }))
            });

            return acc;
          }, {});

          // Merge template KPAs with agreement KPAs
          this.templateKPATypes = filteredTemplate.kpa_types.map(templateKPA => {
            const agreementKPAs = agreementKPAsByTypeMap[templateKPA.id] || [];

            return {
              ...templateKPA,
              kpas: [
                ...agreementKPAs,
                ...(agreementKPAs.length === 0 ? [this.createEmptyKPA()] : [])
              ]
            };
          });

          this.allocatedWeight = this.sumKpaWeights(this.templateKPATypes);
          this.loadingKPAs = false;
        })
        .catch(error => {
          console.error("Error:", error);
          this.$toasted.error("Failed to load template data");
          this.loadingKPAs = false;
        });
    },

    removeEmployee(index, employeeData) {
      this.selectedEmployees.splice(index, 1);
      const employee = this.employees.find(e => e.id === employeeData.id);
      if (employee) employee.selected = false;
    }
  },

  mounted() {
    this.initializeData();
  }
};
</script>

<style>
.cloudenly-input {
  padding-right: 8px !important;
  padding-left: 8px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  height: 38px !important;
}

.bg-disabled {
  background-color: #eeeeee;
  border-color: transparent;
}

.date-input {
  width: 100%;
  height: 38px !important;
  outline: none;
  border-radius: 0.375rem;
  padding: 0.5rem;
}

.cyc-text {
  font-size: 12px;
  font-weight: 900;
  line-height: 1.3rem;
  color: #878e99;
}

.inner-text {
  font-size: 12px;
  line-height: 1.9rem;
  font-weight: 600;
  text-align: center;
  color: #878e99;
  text-transform: uppercase;
}

.label label {
  display: block;
  font-size: 10px;
}

.cycle {
  border: 1px dashed #878e99;
  border-radius: 5px;
  padding: 12px;
}

.cycle__text {
  font-size: 12px;
  font-weight: 900;
  line-height: 1.3rem;
  color: #878e99;
  letter-spacing: 0.035em;
  height: 17px;
}

.fcard {
  padding: 12px;
  height: 58px;
  margin-top: 18px;
  line-height: 16.8px;
  text-transform: uppercase;
}

.fcard__icon {
  margin-right: 7.5px;
}

.csm {
  width: 12px;
  height: 12px;
}

.fcard__header {
  font-weight: 900;
  font-size: 12px;
  margin-top: -2px;
  letter-spacing: 0.035em;
}

.fcard__text {
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  margin-right: 7.5px;
  letter-spacing: 0.015em;
}

.allocate {
  width: 320px;
  border-radius: 5px;
  padding: 8px;
  background-color: #f7f7ff;
  font-weight: 900;
  font-size: 12px;
  letter-spacing: 0.035em;
}

.allocate__text {
  line-height: 1.4rem;
  text-transform: uppercase;
  color: #321c3b;
}

.allocate__value {
  line-height: 17px;
  color: #ea3c53;
  margin: 3px 10px;
}

.line {
  width: 24px;
  height: 0px;
  transform: rotate(90deg);
  margin-left: 6px;
  margin-right: 6px;
}

.line--dashed {
  border: 0.5px dashed #878e99;
}

.line--straight {
  border: 1px solid #878e99;
}

.kpaplus {
  width: 180px;
  border-radius: 5px;
  background-color: #ffffff;
  padding: 10px;
}

.kpaplus__text {
  font-weight: 900;
  font-size: 13px;
  line-height: 17px;
  letter-spacing: 0.035em;
  margin: 3px 10px;
  color: #f15a29;
}

.ksm {
  margin-left: 11px;
  color: #ea3c53;
  width: 14px;
  height: 14px;
  margin-top: 4px;
}

.kpalist__text {
  font-size: 18px;
  font-weight: bold;
  line-height: 120%;
  letter-spacing: 0.015em;
  color: #321c3b;
  width: 170px;
  height: 22px;
}

.kpalisticon {
  width: 18px;
  height: 18px;
}

.button-layout {
  width: 270px;
  height: 44px;
  margin-top: 29px;
}

.btn-disabled {
  background-color: #eeeeee;
  font-size: 16px;
  cursor: disabled;
}

details>summary {
  display: inline;
  list-style: none;
}

.icon-Size {
  width: 200px;
  height: 200px;
}

.illu-text {
  text-align: center;
  font-weight: 400;
  line-height: 19px;
  font-size: 16px;
  letter-spacing: 0.015em;
}
</style>
